import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Button from '@hfe/max-button';
import Icon from '@max/leez-icon';
import Text from '@hfe/max-text';
import './index.scss';
import Sensor from '@max/mbc-sensor';
import LoadingView from '@max/leez-loading-view';
import { LOAD_MORE_STATUS, LOAD_MORE_TYPE, SHOW_TYPE } from '../types';
export const LoadingMore = (props) => {
    const { loadMoreType, loadMoreStatus, showType, onLoadMore, isLastPage, loadMoreTextColor = '#ffffff' } = props;
    const containerStyle = showType === SHOW_TYPE.HORIZONTAL ? {
        marginRight: '18rpx',
        width: '60rpx',
        height: '100%',
        flexDirection: 'column'
    } : {
        width: '100%',
        height: '70rpx',
        flexDirection: 'row'
    };
    const loadMoreButtonStyle = showType === SHOW_TYPE.HORIZONTAL ? {
        width: '60rpx',
        padding: '0 16rpx',
        height: '200rpx',
        flexDirection: 'column'
    } : {
        width: '168rpx',
        height: '60rpx',
        flexDirection: 'row'
    };
    const loadMoreButtonTextStyle = showType === SHOW_TYPE.HORIZONTAL ? {
        maxWidth: '25rpx',
        color: loadMoreTextColor
    } : {
        color: loadMoreTextColor
    };
    const lastPageStyle = showType === SHOW_TYPE.HORIZONTAL ? {
        width: '60rpx',
        padding: ' 0 16rpx'
    } : {
        height: '60rpx'
    };
    return <>
      <View x-if={loadMoreStatus === LOAD_MORE_STATUS.LOADING} className="loading-more__container" style={containerStyle}>
        <LoadingView level="medium"/>
      </View>
      <View x-if={loadMoreStatus === LOAD_MORE_STATUS.ERROR} className="loading-more__container" style={containerStyle}>
        <Button x-if={!isLastPage && loadMoreType === LOAD_MORE_TYPE.CLICK} className="loading-more__button" style={loadMoreButtonStyle} onPress={onLoadMore}>
          <Text className="loading-more__button-text" style={loadMoreButtonTextStyle}>
            查看更多
          </Text>
          <Icon x-if={showType === SHOW_TYPE.VERTICAL_DOUBLE} name="jiantouxianxia" color={loadMoreTextColor}/>
        </Button>
      </View>
      <View x-if={loadMoreStatus === LOAD_MORE_STATUS.SUCCESS} className="loading-more__container" style={containerStyle}>
        <Sensor x-if={!isLastPage && loadMoreType === LOAD_MORE_TYPE.SCROLL} className="loading-more__sensor" onAppear={() => {
            onLoadMore();
        }}/>
        <Button x-if={!isLastPage && loadMoreType === LOAD_MORE_TYPE.CLICK} className="loading-more__button" style={loadMoreButtonStyle} onPress={onLoadMore}>
          <Text className="loading-more__button-text" style={loadMoreButtonTextStyle}>
            查看更多
          </Text>
          <Icon x-if={showType === SHOW_TYPE.VERTICAL_DOUBLE} name="jiantouxianxia" color={loadMoreTextColor}/>
        </Button>
        <View x-if={isLastPage} style={lastPageStyle}>
          <Text className="loading-more__button-text" style={loadMoreButtonTextStyle}>
            没有更多啦
          </Text>
        </View>
      </View>
    </>;
};
